module.exports = __webpack_public_path__ + "static/media/chat.aa208511.svg";